import * as z from "zod";
import { discountRescueInput } from "./discount-rescue-shared";

export const getDiscountRescueTopFailedCodes = {
  name: "getDiscountRescueTopFailedCodes" as const,
  input: discountRescueInput,
  output: z.object({
    codes: z.array(
      z.object({
        code: z.string(),
        failedAttempts: z.number(),
        recoveredRevenue: z.number(),
      }),
    ),
  }),
};
